export const config = {
  showAds: false,     // Toggle this to control ad display
  showWordCloud: true // Toggle this to control word cloud display
};